import { guideSteps } from '@/mocks/yy';

const loginMethods = [
  { icon: 'ri-cellphone-line', title: '手机号密码', desc: '输入已注册手机号与密码即可登录，简单直接。' },
  { icon: 'ri-shield-keyhole-line', title: '验证码登录', desc: '使用手机验证码快速登录，无需牢记密码。' },
  { icon: 'ri-link', title: '第三方快捷登录', desc: '支持常见第三方账号快捷授权登录，一键直达。' },
];

export default function Guide() {
  return (
    <section id="guide" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-guide-line" aria-hidden="true"></i>
            使用指南
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl text-foreground-950">从入口到登录，四步搞定</h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            无论是新用户还是老朋友，按照以下步骤即可快速完成歪歪官方网站入口访问与账号登录，开始畅享娱乐内容。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {guideSteps.map((s) => (
            <div key={s.step} className="relative rounded-lg bg-background-50 border border-background-200 p-6 pt-8">
              <span className="absolute -top-4 left-6 inline-flex w-10 h-10 items-center justify-center rounded-md bg-accent-500 text-foreground-950 font-heading text-lg">
                {s.step}
              </span>
              <h3 className="mt-3 text-base text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-xl bg-background-950 p-8 md:p-10">
          <h3 className="text-xl md:text-2xl text-background-50 font-heading">支持多种登录方式</h3>
          <p className="mt-3 text-background-50/75 text-sm md:text-base">进入歪歪官方网站首页后，选择最顺手的方式完成登录，快捷又安全。</p>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-5">
            {loginMethods.map((m) => (
              <div key={m.title} className="rounded-lg bg-background-50/5 border border-background-50/10 p-5">
                <span className="inline-flex w-10 h-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${m.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <h4 className="mt-4 text-base text-background-50">{m.title}</h4>
                <p className="mt-1.5 text-sm text-background-50/70 leading-relaxed">{m.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}